import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from './ui/button';
import { Package, LogOut } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminHeader = ({ adminUser, currentPage = '' }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('kaha_session');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true, headers });
    } catch (err) { console.warn('Logout API error:', err.message); }
    localStorage.removeItem('kaha_session');
    toast.success('Sesión cerrada');
    navigate('/admin-login', { replace: true });
  };

  return (
    <header className="border-b bg-white/80 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <a href="/" className="flex items-center gap-2">
            <Package className="w-8 h-8 text-accent" />
            <span className="text-xl font-bold text-primary">KAHA</span>
          </a>
          <span className="text-sm text-muted-foreground border-l pl-4">Panel administrativo</span>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant={currentPage === 'orders' ? 'default' : 'outline'}
            size="sm"
            onClick={() => navigate('/admin')}
            data-testid="btn-nav-orders"
          >
            Órdenes
          </Button>
          <Button
            variant={currentPage === 'costos' ? 'default' : 'outline'}
            size="sm"
            onClick={() => navigate('/admin/costos')}
            data-testid="btn-nav-costos"
          >
            Costos
          </Button>
          <Button
            variant={currentPage === 'facturas' ? 'default' : 'outline'}
            size="sm"
            onClick={() => navigate('/admin/facturas')}
            data-testid="btn-nav-facturas"
          >
            Facturas
          </Button>
          <Button
            variant={currentPage === 'datos' ? 'default' : 'outline'}
            size="sm"
            onClick={() => navigate('/admin/datos')}
            data-testid="btn-nav-datos"
          >
            Datos
          </Button>
          <div className="border-l pl-3 flex items-center gap-2">
            {adminUser?.picture && (
              <img src={adminUser.picture} alt="" className="w-7 h-7 rounded-full" />
            )}
            {adminUser?.name && (
              <span className="text-xs text-muted-foreground hidden sm:inline">{adminUser.name}</span>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="text-muted-foreground hover:text-red-600"
              data-testid="btn-admin-logout"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
